import { ConfigurationViewGuard } from "../parts/ConfigurationViewGuard";
import { KnowledgeHub } from "./knowledge-hub/knowledge-hub";

export function KnowledgeHubConfiguration() {
  return (
    <ConfigurationViewGuard view={"knowledge_hub"}>
      <KnowledgeHub />
    </ConfigurationViewGuard>
  );
}
